import classNames from 'classnames';
import { Button } from 'lego-on-react';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { Shape2, Shape2Icon } from '../Shape2/Shape2';

import './Expander.css';

interface ExpanderProps<T> {
    item: JSX.Element | JSX.Element[];
    children?: JSX.Element | (JSX.Element | '')[];
    onClick: (eventData: T) => void;
    eventData: T;
    isOpen: boolean;
    isClickable?: boolean;
}

export class Expander<T> extends React.PureComponent<ExpanderProps<T>> {
    render() {
        const { item, children, isOpen, isClickable } = this.props;

        return (
            <div className={Bem.cls('expander')}>
                <div
                    className={classNames(
                        Bem.cls('expander', 'item'),
                        Bem.cls('expander', 'item', {
                            clickable: Boolean(isClickable)
                        })
                    )}
                    onClick={isClickable ? this.onExpanderClick : undefined}
                >
                    {children && (
                        <Button
                            cls={classNames(
                                Bem.cls('expander', 'opener'),
                                isOpen &&
                                    Bem.cls('expander', 'opener', {
                                        opened: isOpen
                                    })
                            )}
                            size={'xs'}
                            theme={'clear'}
                            onClick={isClickable ? undefined : this.onExpanderClick}
                        >
                            <span className={Bem.cls('expander', 'opener-icon-wrapper')}>
                                <Shape2
                                    cls={Bem.cls('expander', 'opener-icon')}
                                    width={13}
                                    height={13}
                                    icon={Shape2Icon.verticalArrow}
                                />
                            </span>
                        </Button>
                    )}
                    {item}
                </div>
                {isOpen && <div className={Bem.cls('expander', 'children')}>{children}</div>}
            </div>
        );
    }

    private onExpanderClick = () => {
        const { onClick, eventData } = this.props;

        onClick(eventData);
    };
}
